import http from "@/api/http";

const PREFIX = '/co2save'
const IS_MOCK = process.env.VUE_APP_IS_MOCK == 'true'

async function getStdNoExp(id) {
    let url = `${PREFIX}/getstdnoexp`
    if (!IS_MOCK) {
        return http.get(url, {no:id});
    } else {
        const mockReponse = { 
            data : {
                resultCode: 0,
                msgCode: 0,
                msgName: null,
                msgNameList: null,
                data: {
                    regexp: "/^[Y][0-9]{8}$/"
                }
            }
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function createStudent(studentInfo) {
    let url = `${PREFIX}/student`
    if (!IS_MOCK) {
        return http.post(url, studentInfo);
    } else {
        const mockReponse = { 
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function getStudent(studentInfo) {
    let url = `${PREFIX}/studentreg`
    if (!IS_MOCK) {
        return http.post(url, studentInfo);
    } else {
        const mockReponse = { 
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function getStudentImpl(studentImpl) {
    let url = `${PREFIX}/studentimpl`
    if (!IS_MOCK) {
        return http.post(url, studentImpl);
    } else {
        const mockReponse = 
        {
            "totalcount": 5,
            "list": [
                {
                    "insertId": null,
                    "createDateTime": null,
                    "updateDateTime": null,
                    "schoolNo": 562,
                    "regYear": 2025,
                    "studentNo": null,
                    "gradeName": "교직원",
                    "className": null,
                    "num": null,
                    "rank": 0,
                    "personalTargetValue": 0,
                    "personalImplRate": 0,
                    "personalImplValue": 0,
                    "dayImplCo2SaveValue": 0,
                    "dayImplCo2SaveRate": 0,
                    "implDate": "2025-05-12",
                    "implList": [
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "학교잔반제로",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 1,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 1,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동_등교",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 4,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 2,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동_하교",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 13,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 3,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 22,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 4,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "잔반제로실천(가정/직장)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 23,
                            "inputType": 6,
                            "textData": [],
                            "unit": "명",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 5,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (HOT아메리카노)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 24,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 6,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (ICE아메리카노)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 25,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 7,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "에코백사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 26,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 8,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "다회용기사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 27,
                            "inputType": 4,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 9,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "독서하기(스마트폰 사용 줄이기)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 28,
                            "inputType": 5,
                            "textData": [],
                            "unit": "분",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 10,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용하기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 30,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 11,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "자원 절약",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 31,
                            "inputType": 7,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 4,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 12,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "메일함 비우기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 32,
                            "inputType": 8,
                            "textData": [],
                            "unit": "건",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 13,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "학교급식 잔반제로",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 51,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 30,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전등 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 54,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 31,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 냉난방기 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 55,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 32,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 공기청정기 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 56,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 33,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전자칠판 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 57,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 34,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "물티슈 대신 수건/걸레 사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 58,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 35,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "휴대전화 1시간 줄이기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 59,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 36,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "분리배출 올바르게 하기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 60,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 37,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 43,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 23,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러 사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 44,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 24,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "전체 탄소배출 절감량 (kgCO2)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 0,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 0,
                            "imgLink": [],
                            "showOrder": 0
                        }
                    ]
                },
                {
                    "insertId": null,
                    "createDateTime": null,
                    "updateDateTime": null,
                    "schoolNo": 562,
                    "regYear": 2025,
                    "studentNo": null,
                    "gradeName": "1",
                    "className": null,
                    "num": null,
                    "rank": 0,
                    "personalTargetValue": 0,
                    "personalImplRate": 0,
                    "personalImplValue": 0,
                    "dayImplCo2SaveValue": 0,
                    "dayImplCo2SaveRate": 0,
                    "implDate": "2025-05-12",
                    "implList": [
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "학교잔반제로",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 1,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 1,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동_등교",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 4,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 2,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동_하교",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 13,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 3,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 22,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 4,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "잔반제로실천(가정/직장)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 23,
                            "inputType": 6,
                            "textData": [],
                            "unit": "명",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 5,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (HOT아메리카노)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 24,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 6,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (ICE아메리카노)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 25,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 7,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "에코백사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 26,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 8,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "다회용기사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 27,
                            "inputType": 4,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 9,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "독서하기(스마트폰 사용 줄이기)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 28,
                            "inputType": 5,
                            "textData": [],
                            "unit": "분",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 10,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용하기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 30,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 11,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "자원 절약",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 31,
                            "inputType": 7,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 4,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 12,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "메일함 비우기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 32,
                            "inputType": 8,
                            "textData": [],
                            "unit": "건",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 13,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "학교급식 잔반제로",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 51,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 30,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전등 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 54,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 31,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 냉난방기 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 55,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 32,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 공기청정기 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 56,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 33,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전자칠판 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 57,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 34,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "물티슈 대신 수건/걸레 사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 58,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 35,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "휴대전화 1시간 줄이기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 59,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 36,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "분리배출 올바르게 하기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 60,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 37,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 43,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 23,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러 사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 44,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 24,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "전체 탄소배출 절감량 (kgCO2)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 0,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 0,
                            "imgLink": [],
                            "showOrder": 0
                        }
                    ]
                },
                {
                    "insertId": null,
                    "createDateTime": null,
                    "updateDateTime": null,
                    "schoolNo": 562,
                    "regYear": 2025,
                    "studentNo": null,
                    "gradeName": "2",
                    "className": null,
                    "num": null,
                    "rank": 0,
                    "personalTargetValue": 0,
                    "personalImplRate": 0,
                    "personalImplValue": 0,
                    "dayImplCo2SaveValue": 0,
                    "dayImplCo2SaveRate": 0,
                    "implDate": "2025-05-12",
                    "implList": [
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "학교잔반제로",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 1,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 1,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동_등교",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 4,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 2,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동_하교",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 13,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 3,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 22,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 4,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "잔반제로실천(가정/직장)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 23,
                            "inputType": 6,
                            "textData": [],
                            "unit": "명",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 5,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (HOT아메리카노)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 24,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 6,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (ICE아메리카노)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 25,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 7,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "에코백사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 26,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 8,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "다회용기사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 27,
                            "inputType": 4,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 9,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "독서하기(스마트폰 사용 줄이기)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 28,
                            "inputType": 5,
                            "textData": [],
                            "unit": "분",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 10,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용하기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 30,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 11,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "자원 절약",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 31,
                            "inputType": 7,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 4,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 12,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "메일함 비우기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 32,
                            "inputType": 8,
                            "textData": [],
                            "unit": "건",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 13,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "학교급식 잔반제로",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 51,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 30,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전등 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 54,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 31,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 냉난방기 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 55,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 32,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 공기청정기 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 56,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 33,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전자칠판 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 57,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 34,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "물티슈 대신 수건/걸레 사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 58,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 35,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "휴대전화 1시간 줄이기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 59,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 36,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "분리배출 올바르게 하기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 60,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 37,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 43,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 23,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러 사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 44,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 24,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "전체 탄소배출 절감량 (kgCO2)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 0,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 0,
                            "imgLink": [],
                            "showOrder": 0
                        }
                    ]
                },
                {
                    "insertId": null,
                    "createDateTime": null,
                    "updateDateTime": null,
                    "schoolNo": 562,
                    "regYear": 2025,
                    "studentNo": null,
                    "gradeName": "3",
                    "className": null,
                    "num": null,
                    "rank": 0,
                    "personalTargetValue": 0,
                    "personalImplRate": 0,
                    "personalImplValue": 0,
                    "dayImplCo2SaveValue": 0,
                    "dayImplCo2SaveRate": 0,
                    "implDate": "2025-05-12",
                    "implList": [
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "학교잔반제로",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 1,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 1,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동_등교",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 4,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 2,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동_하교",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 13,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 3,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 22,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 4,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "잔반제로실천(가정/직장)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 23,
                            "inputType": 6,
                            "textData": [],
                            "unit": "명",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 5,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (HOT아메리카노)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 24,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 6,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (ICE아메리카노)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 25,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 7,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "에코백사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 26,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 8,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "다회용기사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 27,
                            "inputType": 4,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 9,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "독서하기(스마트폰 사용 줄이기)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 28,
                            "inputType": 5,
                            "textData": [],
                            "unit": "분",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 10,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용하기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 30,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 11,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "자원 절약",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 31,
                            "inputType": 7,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 4,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 12,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "메일함 비우기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 32,
                            "inputType": 8,
                            "textData": [],
                            "unit": "건",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 13,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "학교급식 잔반제로",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 51,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 30,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전등 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 54,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 31,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 냉난방기 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 55,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 32,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 공기청정기 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 56,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 33,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전자칠판 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 57,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 34,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "물티슈 대신 수건/걸레 사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 58,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 35,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "휴대전화 1시간 줄이기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 59,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 36,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "분리배출 올바르게 하기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 60,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 37,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 43,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 23,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러 사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 44,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 24,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "전체 탄소배출 절감량 (kgCO2)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 0,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 0,
                            "imgLink": [],
                            "showOrder": 0
                        }
                    ]
                },
                {
                    "insertId": null,
                    "createDateTime": null,
                    "updateDateTime": null,
                    "schoolNo": 562,
                    "regYear": 2025,
                    "studentNo": "전체 합계",
                    "gradeName": "",
                    "className": "",
                    "num": "",
                    "rank": 0,
                    "personalTargetValue": 0,
                    "personalImplRate": 0,
                    "personalImplValue": 0,
                    "dayImplCo2SaveValue": 0,
                    "dayImplCo2SaveRate": 0,
                    "implDate": "",
                    "implList": [
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "잔반량 합계",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 1,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 1,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동(등교) 실천횟수 합계",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 4,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 2,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동(하교) 실천횟수 합계",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 13,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 3,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러 사용횟수 합계",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 22,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 4,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "가정잔반제로 실천횟수 합계",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 23,
                            "inputType": 6,
                            "textData": [],
                            "unit": "명",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 5,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (HOT아메리카노)",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 24,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 6,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (ICE아메리카노)",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 25,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 7,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "에코백사용",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 26,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 8,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "다회용기사용",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 27,
                            "inputType": 4,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 9,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "독서하기(스마트폰 사용 줄이기)",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 28,
                            "inputType": 5,
                            "textData": [],
                            "unit": "분",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 10,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용하기",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 30,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 11,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "자원 절약",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 31,
                            "inputType": 7,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 4,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 12,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "메일함 비우기",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 32,
                            "inputType": 8,
                            "textData": [],
                            "unit": "건",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 13,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "학교급식 잔반제로",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 51,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 30,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전등 끄기",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 54,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 31,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 냉난방기 끄기",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 55,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 32,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 공기청정기 끄기",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 56,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 33,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전자칠판 끄기",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 57,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 34,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "물티슈 대신 수건/걸레 사용",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 58,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 35,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "휴대전화 1시간 줄이기",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 59,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 36,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "분리배출 올바르게 하기",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 60,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 37,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 43,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 23,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러 사용",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 44,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 24,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "전체 탄소배출 절감량 합계 (kgCO2)",
                            "value": "0",
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 0,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 0,
                            "imgLink": [],
                            "showOrder": 0
                        }
                    ]
                }
            ]
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function setStudentList(studentInfo) {
    let url = `${PREFIX}/studentlist`
    if (!IS_MOCK) {
        return http.post(url, studentInfo);
    } else {
        const mockReponse = { 
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function getStudentList(param) {
    let url = `${PREFIX}/student`
    if (!IS_MOCK) {
        return http.get(url, param);
    } else {
        const mockReponse = { 
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function getCoDashboard(param) {
    let url = `${PREFIX}/co2saveimpl_board`
    if (!IS_MOCK) {
        return http.post(url, param);
    } else {
        const mockReponse = {"data":[ 
            {
                "schoolNo":"Y12345678",
                "studentNo":83,
                "gradeName":"0",
                "className":"0",
                "num":"0",
                "implDate":"2022-09-01",
                "implList": [
                    {"name":"등교교통수단","kgCo2":0,"value":4,"unit":"","inputType":1,mode:0},
                    {"name":"하교교통수단","kgCo2":0,"value":19,"unit":"","inputType":1,mode:0},
                    {"name":"텀블러","kgCo2":0,"value":"1","unit":"번사용","inputType":2,mode:0},
                    {"name":"잔반","kgCo2":0,"value":"12.45","unit":"kg","inputType":0,mode:0},
                ],
                "name":"09-01"
            },
            {
                "schoolNo":"Y12345678",
                "studentNo":83,
                "gradeName":"0",
                "className":"0",
                "num":"0",
                "implDate":"2022-08-31",
                "implList": [{"name":"친환경이동", "leftOver":0,"tumbler":0,"kgCo2":0,"moveItemIn":null,"moveItemOut":null}],
                "name":"08-31"
            },
            {
                "schoolNo":"Y12345678",
                "studentNo":83,
                "gradeName":"0",
                "className":"0",
                "num":"0",
                "implDate":"2022-08-30",
                "implList": [{"name":"친환경이동", "leftOver":0,"tumbler":0,"kgCo2":0,"moveItemIn":null,"moveItemOut":null}],
                "name":"08-30"
            }
        ]
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function getStudentImplRank(studentImpl) {
    let url = `${PREFIX}/studentimplrank`
    if (!IS_MOCK) {
        return http.post(url, studentImpl);
    } else {
        const mockReponse = 
        {
            "totalcount": 4,
            "extTotalcount": 2,
            "list": [
                {
                    "insertId": null,
                    "createDateTime": null,
                    "updateDateTime": null,
                    "schoolNo": 562,
                    "regYear": 2025,
                    "studentNo": "20250001",
                    "gradeName": "1",
                    "className": "1",
                    "num": "1",
                    "rank": 1,
                    "personalTargetValue": 0,
                    "personalImplRate": 0,
                    "personalImplValue": 0,
                    "dayImplCo2SaveValue": 0,
                    "dayImplCo2SaveRate": 0,
                    "implDate": null,
                    "implList": [
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "학교잔반제로",
                            "value": "0.249",
                            "amount": 0.137,
                            "co2Save": 0.249,
                            "countImpl": 2,
                            "avgAmount": 0.069,
                            "saveTypeId": 1,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 1,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동_등교",
                            "value": "0",
                            "amount": 30,
                            "co2Save": 0,
                            "countImpl": 1,
                            "avgAmount": 30,
                            "saveTypeId": 4,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 2,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동_하교",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 13,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 3,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 22,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 4,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "잔반제로실천(가정/직장)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 23,
                            "inputType": 6,
                            "textData": [],
                            "unit": "명",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 5,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (HOT아메리카노)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 24,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 6,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (ICE아메리카노)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 25,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 7,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "에코백사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 26,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 8,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "다회용기사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 27,
                            "inputType": 4,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 9,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "독서하기(스마트폰 사용 줄이기)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 28,
                            "inputType": 5,
                            "textData": [],
                            "unit": "분",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 10,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용하기",
                            "value": "0.013",
                            "amount": 1,
                            "co2Save": 0.013,
                            "countImpl": 1,
                            "avgAmount": 1,
                            "saveTypeId": 30,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 11,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "자원 절약",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 31,
                            "inputType": 7,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 4,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 12,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "메일함 비우기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 32,
                            "inputType": 8,
                            "textData": [],
                            "unit": "건",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 13,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "학교급식 잔반제로",
                            "value": "0.17",
                            "amount": 1,
                            "co2Save": 0.17,
                            "countImpl": 1,
                            "avgAmount": 1,
                            "saveTypeId": 51,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 30,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전등 끄기",
                            "value": "0.713",
                            "amount": 2,
                            "co2Save": 0.713,
                            "countImpl": 2,
                            "avgAmount": 2,
                            "saveTypeId": 54,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 31,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 냉난방기 끄기",
                            "value": "0.026",
                            "amount": 2,
                            "co2Save": 0.026,
                            "countImpl": 2,
                            "avgAmount": 2,
                            "saveTypeId": 55,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 32,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 공기청정기 끄기",
                            "value": "0.327",
                            "amount": 2,
                            "co2Save": 0.327,
                            "countImpl": 2,
                            "avgAmount": 2,
                            "saveTypeId": 56,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 33,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전자칠판 끄기",
                            "value": "0.495",
                            "amount": 2,
                            "co2Save": 0.495,
                            "countImpl": 2,
                            "avgAmount": 2,
                            "saveTypeId": 57,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 34,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "물티슈 대신 수건/걸레 사용",
                            "value": "0.13",
                            "amount": 2,
                            "co2Save": 0.13,
                            "countImpl": 2,
                            "avgAmount": 2,
                            "saveTypeId": 58,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 35,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "휴대전화 1시간 줄이기",
                            "value": "0.003",
                            "amount": 2,
                            "co2Save": 0.003,
                            "countImpl": 2,
                            "avgAmount": 2,
                            "saveTypeId": 59,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 36,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "분리배출 올바르게 하기",
                            "value": "0",
                            "amount": 2,
                            "co2Save": 0,
                            "countImpl": 2,
                            "avgAmount": 2,
                            "saveTypeId": 60,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 37,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용",
                            "value": "0.03",
                            "amount": 2,
                            "co2Save": 0.03,
                            "countImpl": 2,
                            "avgAmount": 2,
                            "saveTypeId": 43,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 23,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러 사용",
                            "value": "0.08",
                            "amount": 2,
                            "co2Save": 0.08,
                            "countImpl": 2,
                            "avgAmount": 2,
                            "saveTypeId": 44,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 24,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "실천 횟수",
                            "value": "23",
                            "amount": 23,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 999,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 999,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "전체 탄소배출 절감량 (kgCO2)",
                            "value": "2.236",
                            "amount": 0,
                            "co2Save": 2.236,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 0,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 0,
                            "imgLink": [],
                            "showOrder": 0
                        }
                    ]
                },
                {
                    "insertId": null,
                    "createDateTime": null,
                    "updateDateTime": null,
                    "schoolNo": 562,
                    "regYear": 2025,
                    "studentNo": "20250005",
                    "gradeName": "1",
                    "className": "1",
                    "num": "5",
                    "rank": 2,
                    "personalTargetValue": 0,
                    "personalImplRate": 0,
                    "personalImplValue": 0,
                    "dayImplCo2SaveValue": 0,
                    "dayImplCo2SaveRate": 0,
                    "implDate": null,
                    "implList": [
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "학교잔반제로",
                            "value": "0.241",
                            "amount": 0,
                            "co2Save": 0.241,
                            "countImpl": 1,
                            "avgAmount": 0,
                            "saveTypeId": 1,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 1,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동_등교",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 4,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 2,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동_하교",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 13,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 3,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 22,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 4,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "잔반제로실천(가정/직장)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 23,
                            "inputType": 6,
                            "textData": [],
                            "unit": "명",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 5,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (HOT아메리카노)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 24,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 6,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (ICE아메리카노)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 25,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 7,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "에코백사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 26,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 8,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "다회용기사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 27,
                            "inputType": 4,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 9,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "독서하기(스마트폰 사용 줄이기)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 28,
                            "inputType": 5,
                            "textData": [],
                            "unit": "분",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 10,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용하기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 30,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 11,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "자원 절약",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 31,
                            "inputType": 7,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 4,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 12,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "메일함 비우기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 32,
                            "inputType": 8,
                            "textData": [],
                            "unit": "건",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 13,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "학교급식 잔반제로",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 51,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 30,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전등 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 54,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 31,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 냉난방기 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 55,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 32,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 공기청정기 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 56,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 33,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전자칠판 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 57,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 34,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "물티슈 대신 수건/걸레 사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 58,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 35,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "휴대전화 1시간 줄이기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 59,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 36,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "분리배출 올바르게 하기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 60,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 37,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 43,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 23,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러 사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 44,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 24,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "실천 횟수",
                            "value": "1",
                            "amount": 1,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 999,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 999,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "전체 탄소배출 절감량 (kgCO2)",
                            "value": "0.241",
                            "amount": 0,
                            "co2Save": 0.241,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 0,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 0,
                            "imgLink": [],
                            "showOrder": 0
                        }
                    ]
                },
                {
                    "insertId": null,
                    "createDateTime": null,
                    "updateDateTime": null,
                    "schoolNo": 562,
                    "regYear": 2025,
                    "studentNo": "20250002",
                    "gradeName": "1",
                    "className": "1",
                    "num": "2",
                    "rank": 3,
                    "personalTargetValue": 0,
                    "personalImplRate": 0,
                    "personalImplValue": 0,
                    "dayImplCo2SaveValue": 0,
                    "dayImplCo2SaveRate": 0,
                    "implDate": null,
                    "implList": [
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "학교잔반제로",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 1,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 1,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동_등교",
                            "value": "0",
                            "amount": 6,
                            "co2Save": 0,
                            "countImpl": 2,
                            "avgAmount": 3,
                            "saveTypeId": 4,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 2,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동_하교",
                            "value": "0",
                            "amount": 3,
                            "co2Save": 0,
                            "countImpl": 1,
                            "avgAmount": 3,
                            "saveTypeId": 13,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 3,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용",
                            "value": "0.011",
                            "amount": 1,
                            "co2Save": 0.011,
                            "countImpl": 1,
                            "avgAmount": 1,
                            "saveTypeId": 22,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 4,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "잔반제로실천(가정/직장)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 23,
                            "inputType": 6,
                            "textData": [],
                            "unit": "명",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 5,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (HOT아메리카노)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 24,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 6,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (ICE아메리카노)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 25,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 7,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "에코백사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 26,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 8,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "다회용기사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 27,
                            "inputType": 4,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 9,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "독서하기(스마트폰 사용 줄이기)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 28,
                            "inputType": 5,
                            "textData": [],
                            "unit": "분",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 10,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용하기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 30,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 11,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "자원 절약",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 31,
                            "inputType": 7,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 4,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 12,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "메일함 비우기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 32,
                            "inputType": 8,
                            "textData": [],
                            "unit": "건",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 13,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "학교급식 잔반제로",
                            "value": "0.17",
                            "amount": 1,
                            "co2Save": 0.17,
                            "countImpl": 1,
                            "avgAmount": 1,
                            "saveTypeId": 51,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 30,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전등 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 54,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 31,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 냉난방기 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 55,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 32,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 공기청정기 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 56,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 33,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전자칠판 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 57,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 34,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "물티슈 대신 수건/걸레 사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 58,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 35,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "휴대전화 1시간 줄이기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 59,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 36,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "분리배출 올바르게 하기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 60,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 37,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 43,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 23,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러 사용",
                            "value": "0.04",
                            "amount": 1,
                            "co2Save": 0.04,
                            "countImpl": 1,
                            "avgAmount": 1,
                            "saveTypeId": 44,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 24,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "실천 횟수",
                            "value": "6",
                            "amount": 6,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 999,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 999,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "전체 탄소배출 절감량 (kgCO2)",
                            "value": "0.221",
                            "amount": 0,
                            "co2Save": 0.221,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 0,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 0,
                            "imgLink": [],
                            "showOrder": 0
                        }
                    ]
                },
                {
                    "insertId": null,
                    "createDateTime": null,
                    "updateDateTime": null,
                    "schoolNo": 562,
                    "regYear": 2025,
                    "studentNo": "20250070",
                    "gradeName": "1",
                    "className": "3",
                    "num": "21",
                    "rank": 4,
                    "personalTargetValue": 0,
                    "personalImplRate": 0,
                    "personalImplValue": 0,
                    "dayImplCo2SaveValue": 0,
                    "dayImplCo2SaveRate": 0,
                    "implDate": null,
                    "implList": [
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "학교잔반제로",
                            "value": "0.12",
                            "amount": 0.071,
                            "co2Save": 0.12,
                            "countImpl": 1,
                            "avgAmount": 0.071,
                            "saveTypeId": 1,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 1,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동_등교",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 4,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 2,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동_하교",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 13,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 3,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 22,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 4,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "잔반제로실천(가정/직장)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 23,
                            "inputType": 6,
                            "textData": [],
                            "unit": "명",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 5,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (HOT아메리카노)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 24,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 6,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (ICE아메리카노)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 25,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 7,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "에코백사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 26,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 8,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "다회용기사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 27,
                            "inputType": 4,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 9,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "독서하기(스마트폰 사용 줄이기)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 28,
                            "inputType": 5,
                            "textData": [],
                            "unit": "분",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 10,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용하기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 30,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 11,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "자원 절약",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 31,
                            "inputType": 7,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 4,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 12,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "메일함 비우기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 32,
                            "inputType": 8,
                            "textData": [],
                            "unit": "건",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 13,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "학교급식 잔반제로",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 51,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 30,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전등 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 54,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 31,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 냉난방기 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 55,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 32,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 공기청정기 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 56,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 33,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전자칠판 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 57,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 34,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "물티슈 대신 수건/걸레 사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 58,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 35,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "휴대전화 1시간 줄이기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 59,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 36,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "분리배출 올바르게 하기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 60,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 37,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 43,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 23,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러 사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 44,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 24,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "실천 횟수",
                            "value": "1",
                            "amount": 1,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 999,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 999,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "전체 탄소배출 절감량 (kgCO2)",
                            "value": "0.12",
                            "amount": 0,
                            "co2Save": 0.12,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 0,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 0,
                            "imgLink": [],
                            "showOrder": 0
                        }
                    ]
                }
            ],
            "extList": [
                {
                    "insertId": null,
                    "createDateTime": null,
                    "updateDateTime": null,
                    "schoolNo": 562,
                    "regYear": 2025,
                    "studentNo": null,
                    "gradeName": "1",
                    "className": "1",
                    "num": null,
                    "rank": 1,
                    "personalTargetValue": 0,
                    "personalImplRate": 0,
                    "personalImplValue": 0,
                    "dayImplCo2SaveValue": 0,
                    "dayImplCo2SaveRate": 0,
                    "implDate": null,
                    "implList": [
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "학교잔반제로",
                            "value": "0.49",
                            "amount": 0.137,
                            "co2Save": 0.49,
                            "countImpl": 3,
                            "avgAmount": 0.046,
                            "saveTypeId": 1,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 1,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동_등교",
                            "value": "0",
                            "amount": 36,
                            "co2Save": 0,
                            "countImpl": 3,
                            "avgAmount": 12,
                            "saveTypeId": 4,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 2,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동_하교",
                            "value": "0",
                            "amount": 3,
                            "co2Save": 0,
                            "countImpl": 1,
                            "avgAmount": 3,
                            "saveTypeId": 13,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 3,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용",
                            "value": "0.011",
                            "amount": 1,
                            "co2Save": 0.011,
                            "countImpl": 1,
                            "avgAmount": 1,
                            "saveTypeId": 22,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 4,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "잔반제로실천(가정/직장)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 23,
                            "inputType": 6,
                            "textData": [],
                            "unit": "명",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 5,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (HOT아메리카노)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 24,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 6,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (ICE아메리카노)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 25,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 7,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "에코백사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 26,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 8,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "다회용기사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 27,
                            "inputType": 4,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 9,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "독서하기(스마트폰 사용 줄이기)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 28,
                            "inputType": 5,
                            "textData": [],
                            "unit": "분",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 10,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용하기",
                            "value": "0.013",
                            "amount": 1,
                            "co2Save": 0.013,
                            "countImpl": 1,
                            "avgAmount": 1,
                            "saveTypeId": 30,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 11,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "자원 절약",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 31,
                            "inputType": 7,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 4,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 12,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "메일함 비우기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 32,
                            "inputType": 8,
                            "textData": [],
                            "unit": "건",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 13,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "학교급식 잔반제로",
                            "value": "0.34",
                            "amount": 2,
                            "co2Save": 0.34,
                            "countImpl": 2,
                            "avgAmount": 1,
                            "saveTypeId": 51,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 30,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전등 끄기",
                            "value": "0.713",
                            "amount": 2,
                            "co2Save": 0.713,
                            "countImpl": 2,
                            "avgAmount": 2,
                            "saveTypeId": 54,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 31,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 냉난방기 끄기",
                            "value": "0.026",
                            "amount": 2,
                            "co2Save": 0.026,
                            "countImpl": 2,
                            "avgAmount": 2,
                            "saveTypeId": 55,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 32,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 공기청정기 끄기",
                            "value": "0.327",
                            "amount": 2,
                            "co2Save": 0.327,
                            "countImpl": 2,
                            "avgAmount": 2,
                            "saveTypeId": 56,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 33,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전자칠판 끄기",
                            "value": "0.495",
                            "amount": 2,
                            "co2Save": 0.495,
                            "countImpl": 2,
                            "avgAmount": 2,
                            "saveTypeId": 57,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 34,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "물티슈 대신 수건/걸레 사용",
                            "value": "0.13",
                            "amount": 2,
                            "co2Save": 0.13,
                            "countImpl": 2,
                            "avgAmount": 2,
                            "saveTypeId": 58,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 35,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "휴대전화 1시간 줄이기",
                            "value": "0.003",
                            "amount": 2,
                            "co2Save": 0.003,
                            "countImpl": 2,
                            "avgAmount": 2,
                            "saveTypeId": 59,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 36,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "분리배출 올바르게 하기",
                            "value": "0",
                            "amount": 2,
                            "co2Save": 0,
                            "countImpl": 2,
                            "avgAmount": 2,
                            "saveTypeId": 60,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 37,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용",
                            "value": "0.03",
                            "amount": 2,
                            "co2Save": 0.03,
                            "countImpl": 2,
                            "avgAmount": 2,
                            "saveTypeId": 43,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 23,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러 사용",
                            "value": "0.12",
                            "amount": 3,
                            "co2Save": 0.12,
                            "countImpl": 3,
                            "avgAmount": 1.5,
                            "saveTypeId": 44,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 24,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "실천 횟수",
                            "value": "30",
                            "amount": 30,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 999,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 999,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "전체 탄소배출 절감량 (kgCO2)",
                            "value": "2.698",
                            "amount": 0,
                            "co2Save": 2.698,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 0,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 0,
                            "imgLink": [],
                            "showOrder": 0
                        }
                    ]
                },
                {
                    "insertId": null,
                    "createDateTime": null,
                    "updateDateTime": null,
                    "schoolNo": 562,
                    "regYear": 2025,
                    "studentNo": null,
                    "gradeName": "1",
                    "className": "3",
                    "num": null,
                    "rank": 2,
                    "personalTargetValue": 0,
                    "personalImplRate": 0,
                    "personalImplValue": 0,
                    "dayImplCo2SaveValue": 0,
                    "dayImplCo2SaveRate": 0,
                    "implDate": null,
                    "implList": [
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "학교잔반제로",
                            "value": "0.12",
                            "amount": 0.071,
                            "co2Save": 0.12,
                            "countImpl": 1,
                            "avgAmount": 0.071,
                            "saveTypeId": 1,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 1,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동_등교",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 4,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 2,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "친환경이동_하교",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 13,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 3,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 22,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 4,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "잔반제로실천(가정/직장)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 23,
                            "inputType": 6,
                            "textData": [],
                            "unit": "명",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 5,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (HOT아메리카노)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 24,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 6,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러사용 (ICE아메리카노)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 25,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 7,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "에코백사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 26,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 8,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "다회용기사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 27,
                            "inputType": 4,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 9,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "독서하기(스마트폰 사용 줄이기)",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 28,
                            "inputType": 5,
                            "textData": [],
                            "unit": "분",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 10,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용하기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 30,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 11,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "자원 절약",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 31,
                            "inputType": 7,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 4,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 12,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "메일함 비우기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 32,
                            "inputType": 8,
                            "textData": [],
                            "unit": "건",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 1,
                            "saveTypeNameId": 13,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "학교급식 잔반제로",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 51,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 30,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전등 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 54,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 31,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 냉난방기 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 55,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 32,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 공기청정기 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 56,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 33,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "교실 전자칠판 끄기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 57,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 34,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "물티슈 대신 수건/걸레 사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 58,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 35,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "휴대전화 1시간 줄이기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 59,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 36,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "분리배출 올바르게 하기",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 60,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 37,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "계단 이용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 43,
                            "inputType": 2,
                            "textData": [],
                            "unit": "회",
                            "inputTypeUseCount": 1,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 23,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "텀블러 사용",
                            "value": null,
                            "amount": 0,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 44,
                            "inputType": 1,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 2,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 24,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "실천 횟수",
                            "value": "1",
                            "amount": 1,
                            "co2Save": 0,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 999,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 999,
                            "imgLink": [],
                            "showOrder": 0
                        },
                        {
                            "insertId": null,
                            "createDateTime": null,
                            "updateDateTime": null,
                            "saveTypeName": "전체 탄소배출 절감량 (kgCO2)",
                            "value": "0.12",
                            "amount": 0,
                            "co2Save": 0.12,
                            "countImpl": 0,
                            "avgAmount": 0,
                            "saveTypeId": 0,
                            "inputType": 0,
                            "textData": [],
                            "unit": "",
                            "inputTypeUseCount": 0,
                            "inputTypeUseImage": 0,
                            "saveTypeNameId": 0,
                            "imgLink": [],
                            "showOrder": 0
                        }
                    ]
                }
            ]
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function setStudentImpl(studentImpl) {
    let url = `${PREFIX}/co2saveimpl`
    if (!IS_MOCK) {
        return http.post(url, studentImpl);
    } else {
        const mockReponse = { 
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function schoolSelect(selectInfo) {
    let url = `${PREFIX}/schoolselect`
    if (!IS_MOCK) {
        return http.post(url, selectInfo);
    } else {
        const mockReponse = { 
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function getSaveRate(saveInfo) {
    let url = `${PREFIX}/get_saverate`
    if (!IS_MOCK) {
        return http.post(url, saveInfo);
    } else {
        const mockReponse = { 
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function setSaveRate(saveInfo) {
    let url = `${PREFIX}/set_saverate`
    if (!IS_MOCK) {
        return http.post(url, saveInfo);
    } else {
        const mockReponse = { 
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function getStatisticsSave(saveInfo) {
    let url = `${PREFIX}/statistics_save`
    if (!IS_MOCK) {
        return http.post(url, saveInfo);
    } else {
        const mockReponse = { 
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function getCo2AmountList(param) {
    let url = `${PREFIX}/getco2amount`
    if (!IS_MOCK) {
        return http.post(url, param);
    } else {
        const mockReponse = { 
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function setCo2AmountList(param) {
    let url = `${PREFIX}/co2amountlist`
    if (!IS_MOCK) {
        return http.post(url, param);
    } else {
        const mockReponse = { 
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function getCo2SaveItems(param) {
    let url = `${PREFIX}/getco2saveitems`
    if (!IS_MOCK) {
        return http.post(url, param);
    } else {
        const mockReponse = { 
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function setCo2SaveItems(param) {
    let url = `${PREFIX}/setco2saveitems`
    if (!IS_MOCK) {
        return http.post(url, param);
    } else {
        const mockReponse = { 
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function getInputTypes() {
    let url = `${PREFIX}/co2saveinputtype`
    if (!IS_MOCK) {
        return http.get(url);
    } else {
        const mockReponse = 
        {
            "list": [
                {
                    "insertId": null,
                    "createDateTime": null,
                    "updateDateTime": null,
                    "id": 0,
                    "description": "입력없음",
                    "useCount": 0,
                    "useImage": 0,
                    "placeHolder": null,
                    "unit": "",
                    "countMin": 0,
                    "countMax": 0
                },
                {
                    "insertId": null,
                    "createDateTime": null,
                    "updateDateTime": null,
                    "id": 1,
                    "description": "리스트선택입력",
                    "useCount": 2,
                    "useImage": 0,
                    "placeHolder": null,
                    "unit": "",
                    "countMin": 0,
                    "countMax": 0
                },
                {
                    "insertId": null,
                    "createDateTime": null,
                    "updateDateTime": null,
                    "id": 2,
                    "description": "카운트숫자입력",
                    "useCount": 1,
                    "useImage": 0,
                    "placeHolder": "사용수량 입력",
                    "unit": "회",
                    "countMin": 0,
                    "countMax": 0
                },
                {
                    "insertId": null,
                    "createDateTime": null,
                    "updateDateTime": null,
                    "id": 3,
                    "description": "실수값입력",
                    "useCount": 3,
                    "useImage": 0,
                    "placeHolder": null,
                    "unit": "회",
                    "countMin": 0,
                    "countMax": 0
                },
                {
                    "insertId": null,
                    "createDateTime": null,
                    "updateDateTime": null,
                    "id": 4,
                    "description": "카운트숫자,이미지입력",
                    "useCount": 1,
                    "useImage": 1,
                    "placeHolder": "사용수량 입력",
                    "unit": "회",
                    "countMin": 1,
                    "countMax": 10
                },
                {
                    "insertId": null,
                    "createDateTime": null,
                    "updateDateTime": null,
                    "id": 5,
                    "description": "시간분입력,이미지입력",
                    "useCount": 1,
                    "useImage": 1,
                    "placeHolder": "독서시간(분) 입력",
                    "unit": "분",
                    "countMin": 1,
                    "countMax": 180
                },
                {
                    "insertId": null,
                    "createDateTime": null,
                    "updateDateTime": null,
                    "id": 6,
                    "description": "인원수입력,이미지입력",
                    "useCount": 1,
                    "useImage": 1,
                    "placeHolder": "실천인원수 입력",
                    "unit": "명",
                    "countMin": 1,
                    "countMax": 20
                },
                {
                    "insertId": null,
                    "createDateTime": null,
                    "updateDateTime": null,
                    "id": 7,
                    "description": "텍스트입력,이미지입력",
                    "useCount": 4,
                    "useImage": 1,
                    "placeHolder": "실천내용 입력",
                    "unit": "회",
                    "countMin": 0,
                    "countMax": 0
                },
                {
                    "insertId": null,
                    "createDateTime": null,
                    "updateDateTime": null,
                    "id": 8,
                    "description": "메일카운트,이미지입력",
                    "useCount": 1,
                    "useImage": 1,
                    "placeHolder": "삭제 메일 건수",
                    "unit": "건",
                    "countMin": 1,
                    "countMax": 10000
                },
                {
                    "insertId": null,
                    "createDateTime": null,
                    "updateDateTime": null,
                    "id": 9,
                    "description": "시간분입력",
                    "useCount": 1,
                    "useImage": 0,
                    "placeHolder": "시간(분) 입력",
                    "unit": "분",
                    "countMin": 1,
                    "countMax": 1440
                }
            ]
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function setInputTypes(param) {
    let url = `${PREFIX}/co2saveinputtype`
    if (!IS_MOCK) {
        return http.post(url, param);
    } else {
        const mockReponse = { 
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function getImplItemDetail() {
    let url = `${PREFIX}/co2savetype`
    if (!IS_MOCK) {
        return http.get(url);
    } else {
        const mockReponse = { 
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function setImplItemDetail(param) {
    let url = `${PREFIX}/co2savetypelist`
    if (!IS_MOCK) {
        return http.post(url, param);
    } else {
        const mockReponse = { 
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function checkIsCMonitorSchool(no) {
    let url = `${PREFIX}/school`
    if (!IS_MOCK) {
        return http.get(url, {no});
    } else {
        const mockReponse = { 
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        })
    }
}

async function getEarthImageEffect(schoolNo){
    let url = `${PREFIX}/earth`;
    if(!IS_MOCK) {
        return http.get(url, {dir:schoolNo});
    } else {
        const mockResponse = {

            "earth":"{\"earthImage\":[null,null,\"earthImage03.bin\",null,null],\"effectImage\":[null,null,\"effectImage03.bin\",null,null],\"earthIcon\":[\"earthIcon01.bin\",null,\"earthIcon03.bin\",null,null],\"effectSound\":[null,null,\"effectSound03.bin\",null,null],\"earthText\":[\"잔반을 줄여 퍼즐을 벗기면 푸른 지구를 만날 수 있어요!\",\"2\",\"3\",\"4\",\"5\"]}","dir":"704"}
        
        return new Promise((resolve) => {
        setTimeout(() => {
            resolve(mockResponse);
        }, 100);
        })
    }
}

async function setEarthImageEffect(param){
    let url = `${PREFIX}`
    return http.post(url, param, {headers : {
        'Content-type' : 'multipart/form-data'
    }});
}

export default {
    getStdNoExp,
    //gettransportList,
    createStudent,
    getStudent,
    getStudentImpl,
    setStudentList,
    getStudentList,
    getCoDashboard,
    getStudentImplRank,
    setStudentImpl,
    schoolSelect,
    getSaveRate,
    setSaveRate,
    getStatisticsSave,
    getCo2AmountList,
    setCo2AmountList,
    getCo2SaveItems,
    setCo2SaveItems,
    getInputTypes,
    setInputTypes,
    getImplItemDetail,
    setImplItemDetail,
    checkIsCMonitorSchool,
    getEarthImageEffect,
    setEarthImageEffect
};
